import script from "./ChatBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBubble.vue?vue&type=script&setup=true&lang=js"

import "./ChatBubble.vue?vue&type=style&index=0&id=e075ad1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e075ad1e"]])

export default __exports__